<template>
  <div class="page-steps">
    <div class="step" :class="{ 'active': step.active }" :style="{ width: width() }" :key="step.name"
      v-for="(step, i) in steps">
      <div class="number">{{ i + 1 }}</div>
      {{ step.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageSteps',
  props: {
    steps: {
      type: Array,
      default: []
    }
  },
  methods: {
    width() {
      return `${100 / this.steps.length}%`;
    }
  }
};
</script>

<style lang="scss">
.page-steps {
  display: inline-block;
  width: 100%;

  >.step {
    position: relative;
    float: left;
    padding: 15px 15px 15px 45px;
    width: 100%;
    text-align: center;

    &.active {
      color: #fff;
      background-color: $brand-colour-primary;

      .number {
        color: #fff;
        background-color: darken($brand-colour-primary, 10%);
      }
    }
  }

  .number {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translate(0, -50%);
    height: 25px;
    width: 25px;
    border-radius: 50%;
    text-align: center;
    line-height: 25px;
    font-size: 11px;
    font-weight: bold;
    color: #5d5d5d;
    background-color: #dcdcdc;
  }

  @media (max-width: 767px) {
    >.step {
      font-size: 10px;
      padding: 40px 10px 10px 10px;
    }

    .number {
      left: 50%;
      top: 8px;
      transform: translate(-50%, 0);
    }
  }
}
</style>
